import { IconProps } from "./icon.type";

export function IcAi(props: IconProps) {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1416 4.84619C22.4275 5.23674 22.7706 5.58152 23.1592 5.86865C22.7716 6.15122 22.4291 6.49035 22.1426 6.87451C21.8594 6.48776 21.5206 6.14532 21.1367 5.85986C21.5203 5.57459 21.8587 5.2326 22.1416 4.84619Z"
        fill="black"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M13.6899 23.1441L13.6219 22.7313C12.918 18.4541 9.6157 15.1026 5.40119 14.3883L4.85381 14.2954C4.60472 14.2533 4.60472 13.8897 4.85381 13.8476L5.40119 13.7547C9.6157 13.0404 12.918 9.68889 13.6219 5.41163L13.7134 4.8561C13.7549 4.6033 14.1131 4.6033 14.1546 4.8561L14.2461 5.41163C14.95 9.68889 18.2523 13.0404 22.4668 13.7547L23.1468 13.8698C23.3913 13.9111 23.3978 14.2658 23.1549 14.3161L22.0432 14.5466C18.0073 15.3841 14.9043 18.6411 14.1944 22.7313C14.1712 22.8656 14.1504 23.0007 14.1323 23.1367C14.0981 23.3945 13.7318 23.4008 13.6899 23.1441Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
}
